<template>
    <footer class="footer d-print-none" v-if="totalResults">
        <div class="row">
            <div class="col-3">
                <b-button
                    @click="showFilters()"
                    class="d-lg-none"
                    size="sm"
                    variant="outline-primary"
                >
                    Filters
                </b-button>
            </div>
            <nav class="col-6">
                <b-pagination
                    @change="onPageChange"
                    :per-page="perPage"
                    :total-rows="totalResults"
                    align="center"
                    size="sm"
                    v-model="currentPage"
                ></b-pagination>
            </nav>
            <div class="col-3 text-right">
                <b-button @click="buildCSV" size="sm" variant="primary">
                    Download
                </b-button>
            </div>
        </div>
    </footer>
</template>

<script>
import { jsonToCsv } from "@/shared/export";
import { store } from "@/shared/store";

export default {
    name: "GridFooter",
    props: {
        filteredItems: {
            type: Array,
            default: null
        },
        perPage: {
            type: Number,
            default: 0
        },
        totalResults: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            currentPage: 1
        };
    },
    methods: {
        /**
         * Emit page change to parent
         */
        onPageChange(page) {
            this.$emit("pageChange", page);
        },

        /**
         * Bring filters into view
         */
        showFilters() {
            this.$nextTick(function() {
                document.getElementById("app-sidebar").scrollIntoView();
            });
        },

        /**
         * Convert JSON to CSV
         */
        async buildCSV() {
            store.clearToast();

            if (this.totalResults === 0) return;

            const csv = await jsonToCsv({
                data: this.filteredItems
            });

            if (!csv) this.showCSVError();
            else this.downloadCSV(csv);
        },

        /**
         * Download CSV
         */
        downloadCSV(csv) {
            const filename = "export.csv";
            const blob = new Blob([csv], { type: "text/csv" });

            // handle differences in browsers (Edge/IE vs others)
            if (window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveBlob(blob, filename);
            } else {
                let elem = window.document.createElement("a");
                elem.href = window.URL.createObjectURL(blob);
                elem.download = filename;
                document.body.appendChild(elem);
                elem.click();
                document.body.removeChild(elem);
            }
        },

        /**
         * Show toast message if CSV doesn't build
         */
        showCSVError() {
            console.error("Invalid CSV!");

            const toast = {
                message: "Export failed. Invalid CSV."
            };
            store.setToast(toast);
        }
    }
};
</script>
